import { render, staticRenderFns } from "./HandlingFormDetail.vue?vue&type=template&id=059d2675&scoped=true&"
import script from "./HandlingFormDetail.vue?vue&type=script&lang=js&"
export * from "./HandlingFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./HandlingFormDetail.vue?vue&type=style&index=0&id=059d2675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d2675",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059d2675')) {
      api.createRecord('059d2675', component.options)
    } else {
      api.reload('059d2675', component.options)
    }
    module.hot.accept("./HandlingFormDetail.vue?vue&type=template&id=059d2675&scoped=true&", function () {
      api.rerender('059d2675', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/handling/HandlingFormDetail.vue"
export default component.exports